import { createRouter, createWebHistory } from 'vue-router'
import _ from '../views/_.vue'
import search from '../views/search.vue'

const routes = [
  {
    path: '/',
    name: 'index',
    component: _
  },
  {
    path: '/search',
    name: 'search',
    component: search,
    props: (route) => ({ query: route.query.q })
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
